import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfCarousel.module.scss';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { Carousel, Grid } from '@/components';
import { useEffect, useState } from 'react';

let cx = classNames.bind(styles);

export default function AcfCarousel(props) {
	const { carousel, attributes, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];
	const [displayCarousel, setDisplayCarousel] = useState(true);
	const [autoHeight, setAutoHeight] = useState(null);

	useEffect(() => {
		function handleWindowResize() {
			if ((window.innerWidth < 821 && carousel.disableOn === 'mobile') || (window.innerWidth >= 821 && carousel.disableOn === 'desktop')) {
				setDisplayCarousel(false);
			} else {
				setDisplayCarousel(true);
			}
			if ((window.innerWidth < 821 && carousel.autoHeight.mobile) || (window.innerWidth >= 821 && carousel.autoHeight.desktop)) {
				setAutoHeight(true);
			} else {
				setAutoHeight(false);
			}
		}
		handleWindowResize();
		window.addEventListener('resize', handleWindowResize);
		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, []);

	if (displayCarousel === null) return;

	return displayCarousel ? (
		<Carousel autoplay={carousel.autoplay} autoplaySettings={carousel.autoplaySettings} pagination={carousel.pagination} previousNextControls={carousel.previousNextControls} id={attributes.anchor} className={cx([...className, attributes.alignContent && `align-content-${attributes.alignContent}`, attributes.fullHeight && 'full-height'])} slidesDisplayed={carousel.slidesDisplayed} declareSlideSize={carousel.declareSlideSize} gutterSize={carousel.gutterSize} peakaboo={carousel.mobilePeakaboo} loop={carousel.loop} autoHeight={autoHeight}>
			{innerBlocks.map((slide, index) => (
				<WordPressBlocksViewer key={index} blocks={[slide] ?? []} />
			))}
		</Carousel>
	) : (
		<Grid colCount={carousel.slidesDisplayed}>
			<WordPressBlocksViewer blocks={innerBlocks ?? []} />
		</Grid>
	);
}

AcfCarousel.fragments = {
	key: `AcfCarouselFragment`,
	entry: gql`
		fragment AcfCarouselFragment on AcfCarousel {
			attributes {
				anchor
				className
				alignContent
				fullHeight
			}
			carousel {
				autoplay
				autoplaySettings {
					pauseOnMouseEnter
					playStyle
					slideDuration
					scrollSpeed
				}
				declareSlideSize
				pagination
				previousNextControls
				slidesDisplayed
				disableOn
				gutterSize
				mobilePeakaboo
				loop
				autoHeight {
					mobile
					desktop
				}
			}
		}
	`,
};

AcfCarousel.config = {
	name: 'AcfCarousel',
};
AcfCarousel.displayName = 'AcfCarousel';
